import { SickLeaveApplicationStatus } from '../../api-client';

export function sickLeaveApplicationStatusToString(status: SickLeaveApplicationStatus): string {
  return status;
}

export function stringToSickLeaveApplicationStatus(
  status: string | undefined
): SickLeaveApplicationStatus | undefined {
  if (!status) return undefined;
  const validStatuses = Object.values(SickLeaveApplicationStatus) as string[];
  if (validStatuses.includes(status)) {
    return status as SickLeaveApplicationStatus;
  }
  return undefined;
}

export function getSickLeaveApplicationStatusLabel(status: SickLeaveApplicationStatus): string {
  switch (status) {
    case SickLeaveApplicationStatus.PENDING:
      return 'Ожидает обработки';
    case SickLeaveApplicationStatus.ACTIVE:
      return 'Активен';
    case SickLeaveApplicationStatus.COMPLETED:
      return 'Завершен';
    case SickLeaveApplicationStatus.CANCELED:
      return 'Отменен';
    default:
      return status;
  }
}

export function getSickLeaveApplicationStatusBadgeVariant(
  status: SickLeaveApplicationStatus
): string {
  switch (status) {
    case SickLeaveApplicationStatus.PENDING:
      return 'warning';
    case SickLeaveApplicationStatus.ACTIVE:
      return 'info';
    case SickLeaveApplicationStatus.COMPLETED:
      return 'success';
    case SickLeaveApplicationStatus.CANCELED:
      return 'danger';
    default:
      return 'secondary';
  }
}
